const CdcDeviceList = () => import('Views/cdcDevice/cdc-device-list');

export default[
  { path: '/cdc-device-list', component: CdcDeviceList },
];



// WEBPACK FOOTER //
// ./src/router/cdcDevice.js